export default {
  "notifications": {
    "broken_favorite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Post anaithnid. Cuardach dó…"])},
    "favorited_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["toghadh le do phost"])},
    "followed_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["lean tú"])},
    "load_older": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Luchtaigh fógraí aosta"])},
    "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fógraí"])},
    "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Léigh!"])},
    "repeated_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["athphostáil tú"])}
  }
}